import { useI18n, LOCALES } from "@/lib/i18n";

interface LocaleSelectorProps {
  className?: string;
  showNames?: boolean;
}

export function LocaleSelector({ className = "", showNames = true }: LocaleSelectorProps) {
  const { locale, setLocale } = useI18n();

  return (
    <div className={`flex gap-2 ${className}`}>
      {Object.entries(LOCALES).map(([code, config]) => (
        <button
          key={code}
          onClick={(e) => { e.stopPropagation(); setLocale(code as any); }}
          onTouchEnd={(e) => { e.stopPropagation(); e.preventDefault(); setLocale(code as any); }}
          className={`min-w-[44px] min-h-[44px] px-3 py-2 rounded-xl font-bold transition-all text-sm flex items-center justify-center gap-2 ${
            locale === code
              ? "bg-cyan-500 text-white shadow-lg shadow-cyan-500/30 scale-110"
              : "bg-slate-800/80 text-white/70 hover:bg-white/10"
          }`}
          title={config.nativeName}
        >
          <span className="text-xl">{config.flag}</span>
          {showNames && <span className="hidden sm:inline">{code}</span>}
        </button>
      ))}
    </div>
  );
}

export default LocaleSelector;
